export default __webpack_public_path__ + "static/media/floppy-disk.1dfbe2c9.svg";